const Routes = {
  //Auth routes
  entity: "/entity",
  // rule:"/rule"
};

export { Routes };
